module.exports = __webpack_public_path__ + "static/media/youtubePlaceHolder.69575f58.png";